export default __webpack_public_path__ + "static/media/Help.314b7306.svg";